$(document).ready(function() {
	$('.popup-trigger').on('click', function() {
		var clickedID = $(this).attr('id');
		var location = locationsArray[clickedID];

		$('#popup-image').attr('src', location.image);
		$('#popup-text').html(location.text);

		$('#myModal').removeClass('d-none');
		$('#myModal').addClass('d-block');
	});

	$('#close-modal, #close-modal-footer').on('click', function() {
		$('#myModal').removeClass('d-block');
		$('#myModal').addClass('d-none');
	});
});
